import { useTranslation } from 'react-i18next';

export default function MainSiteCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 lg:px-10 text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-background-50 mb-4">
          {t('mainSite.title')}
        </h2>
        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8">
          {t('mainSite.description')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center px-8 py-4 bg-background-50 text-primary-700 font-semibold text-base rounded-md hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            {t('mainSite.title')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center px-8 py-4 border-2 border-background-50 text-background-50 font-semibold text-base rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap"
          >
            {t('mainSite.button')}
          </a>
        </div>
      </div>
    </section>
  );
}